import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { ProductosService } from 'src/app/services/productos.service';

@Component({
  selector: 'app-plantillas',
  templateUrl: './plantillas.component.html',
  styleUrls: ['./plantillas.component.scss']
})
export class PlantillasComponent implements OnInit {
  respuestaDedicatorias:any;
  respuestaEditar:any;
  respuestaAgregar:any;
  respuestaUpdate:any;

  datos;
  dedicatorias;
  data;
  formularioEdit;
  formulario;
  dedicatoriaId;

  constructor(private _get:ProductosService, private modalService: NgbModal, private _update:ClientesService,
    private _editar:ClientesService,  private _agregar:ClientesService,
    private iziToast: Ng2IzitoastService,) { }

  ngOnInit(): void {
    this.getDedicatorias();

    this.formulario = {
      texto:'',
      nombre:'',
    }

    this.formularioEdit = {
      texto:'',
      nombre:'',
    }

  }

  getDedicatorias(){
    this._get.getDedicatorias().subscribe(
      data => {
        this.respuestaDedicatorias = data;
        if(this.respuestaDedicatorias.success){
          this.dedicatorias = this.respuestaDedicatorias.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarDedicatoria(){
    this.data = {
      'texto': this.formulario.texto,
      'nombre': this.formulario.nombre
    }

    this._agregar.agregarDedicatoria(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dismissAll();
          this.getDedicatorias();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarDedicatoria(dedicatoria){
    this.data = {
      'dedicatoria':dedicatoria,
    }

    this._editar.editarDedicatoria(this.data).subscribe(
      data => {
        this.respuestaEditar = data;
        if(this.respuestaEditar.success){
          this.datos = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datos.nombre;
          this.formularioEdit.texto = this.datos.texto;
          this.dedicatoriaId = dedicatoria;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateDedicatoria(dedicatoria){
    this.data = {
      'dedicatoria':dedicatoria,
      'texto':this.formularioEdit.texto,
      'nombre':this.formularioEdit.nombre,
    }

    this._update.updateDedicatoria(this.data).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el cliente correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getDedicatorias();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
